/**
 * @desc 库存调整单创建导入sku明细
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/createImportStockAdjustmentDetail`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
